import { z } from 'zod'

export const savePersonaSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required')
    .max(100, 'Name must be 100 characters or less'),
  description: z
    .string()
    .max(500, 'Description must be 500 characters or less')
    .optional()
    .or(z.literal('')),
})

export type SavePersonaFormValues = z.infer<typeof savePersonaSchema>
